const ENV = {
  development: 'development',
  staging: 'staging',
  production: 'production',
}

const modeEnv = {
  isStaging: import.meta.env.VITE_APP_ENV === 'staging',
  isDevelopment: import.meta.env.VITE_APP_ENV === 'development',
  isProduction: import.meta.env.VITE_APP_ENV === 'production',
}

const commonConfig = {
  APP_URL: '',
  LARAVEL_ECHO_HOST: '',
  LARAVEL_ECHO_PORT: 8080,
  LARAVEL_ECHO_TLS: false,
  LARAVEL_ECHO_KEY: '',
  BROWSERY_URL: '',
}

const stagingConfig = {
  ...commonConfig,
  APP_URL: `https://fr.private.multi-provider-platform.app.staging.aws.selectra.io`,
  env: ENV.staging,
  LARAVEL_ECHO_TLS: true,
  LARAVEL_ECHO_HOST: 'reverb.multi-provider-platform.app.staging.aws.selectra.io',
  LARAVEL_ECHO_KEY: '3tvydc2qzvu0wbg1xpjd',
  LARAVEL_ECHO_PORT: 443,
  BROWSERY_URL: 'https://integrations.app.staging.aws.selectra.io',
}

const developmentConfig = {
  ...stagingConfig,
  APP_URL: `http://localhost:8080`,
  env: ENV.development,
  LARAVEL_ECHO_HOST: '127.0.0.1',
  LARAVEL_ECHO_PORT: 8081,
  LARAVEL_ECHO_KEY: '3tvydc2qzvu0wbg1xpjd',
  LARAVEL_ECHO_TLS: false,
}

const productionConfig = {
  ...commonConfig,
  APP_URL: `https://hop.selectra.io`,
  env: ENV.production,
  LARAVEL_ECHO_TLS: true,
  LARAVEL_ECHO_HOST: 'reverb.multi-provider-platform.app.production.aws.selectra.io',
  LARAVEL_ECHO_KEY: '3tvydc2qzvu0wbg1xpjd',
  LARAVEL_ECHO_PORT: 443,
  BROWSERY_URL: 'https://integrations.app.production.aws.selectra.io',
}

const runtimeConfigByEnv = {
  [ENV.development]: developmentConfig,
  [ENV.staging]: stagingConfig,
  [ENV.production]: productionConfig,
}

function getRuntimeConfig() {
  const allowedEnv = Object.values(ENV)
  if (!allowedEnv.includes(import.meta.env.VITE_APP_ENV)) {
    return developmentConfig
  }
  const envRuntimeConfig = runtimeConfigByEnv[import.meta.env.VITE_APP_ENV]
  return { ...envRuntimeConfig, ...modeEnv }
}

export const runtimeConfig = getRuntimeConfig()
